import { jsx as _jsx } from "preact/jsx-runtime";
import { UIPlugin } from '@uppy/core';
import { RequestClient, tokenStorage, } from '@uppy/core/companion-client';
import { GooglePhotosIcon, GooglePickerView } from '@uppy/core/provider-views';
import packageJson from '../package.json' with { type: 'json' };
import locale from './locale.js';
export default class GooglePhotosPicker extends UIPlugin {
    static VERSION = packageJson.version;
    static requestClientId = GooglePhotosPicker.name;
    type = 'acquirer';
    icon = GooglePhotosIcon;
    storage;
    defaultLocale = locale;
    requestClientId = GooglePhotosPicker.requestClientId;
    constructor(uppy, opts) {
        super(uppy, opts);
        this.id = this.opts.id || 'GooglePhotosPicker';
        this.storage = this.opts.storage || tokenStorage;
        this.defaultLocale = locale;
        this.i18nInit();
        this.title = this.i18n('pluginNameGooglePhotosPicker');
        this.setPluginState({
            loading: false,
            accessToken: undefined,
        });
        this.getPluginState = this.getPluginState.bind(this);
        this.setPluginState = this.setPluginState.bind(this);
        const requestClient = new RequestClient(uppy, {
            companionUrl: this.opts.companionUrl,
            companionHeaders: this.opts.companionHeaders,
            companionCookiesRule: this.opts.companionCookiesRule,
            companionKeysParams: this.opts.companionKeysParams,
        });
        this.uppy.registerRequestClient(GooglePhotosPicker.requestClientId, requestClient);
    }
    install() {
        const { target } = this.opts;
        if (target) {
            this.mount(target, this);
        }
    }
    uninstall() {
        this.unmount();
    }
    render = () => (_jsx(GooglePickerView, { getPluginState: this.getPluginState, setPluginState: this.setPluginState, storage: this.storage, pickerType: "photos", uppy: this.uppy, i18n: this.i18n, clientId: this.opts.clientId, requestClientId: GooglePhotosPicker.requestClientId, companionUrl: this.opts.companionUrl }));
}
